import { styled } from '@mui/material';

type StyledIconProps = {
  $withParentColor?: boolean;
  $size?: string | number;
};

export const StyledIcon = styled('span')<StyledIconProps>(({ $withParentColor, $size }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: $size,
  'path, rect, circle': {
    stroke: $withParentColor ? 'currentColor' : undefined,
  },
}));
